import React from 'react';
import { DatasetPickerModal } from './DatasetPickerModal';

interface Dataset {
  id: string;
  name: string;
  updated_at: string;
  table_type?: string;
  lead_count?: number;
}

interface MonitorModalProps {
  isOpen: boolean;
  onClose: () => void;
  datasets: Dataset[];
  onNewDataset: () => void;
}

export const MonitorModal: React.FC<MonitorModalProps> = ({
  isOpen,
  onClose,
  datasets,
  onNewDataset,
}) => (
  <DatasetPickerModal
    isOpen={isOpen}
    onClose={onClose}
    datasets={datasets}
    onNewDataset={onNewDataset}
    title="Create a Monitor"
    description="Select a dataset to monitor, or create a new one first. Monitors track changes and alert you to new matches."
    actionLabel="Create New Dataset"
    actionDescription="Start fresh with a new dataset to monitor"
    navigateOnSelect="?action=monitor"
  />
);
